

import { styled } from '@mui/material/styles';

const Footer = styled('footer')({});

export default Footer;